import { useBundleContext } from './ProductDetailsContext';
import ProductDetailsProductList from './ProductDetailsProductList';

interface Props {
	className?: string;
	heading: string;
	productId: string;
}

export default function ProductDetailsBundleProducts({
	className,
	heading,
	productId,
}: Props) {
	const { isLoading, items: bundleProducts } = useBundleContext();

	return (
		<ProductDetailsProductList
			isLoading={isLoading}
			products={bundleProducts}
			heading={heading}
			gtmItemListId="pdp_bundle_products"
			gtmItemListName={`List: Bundle products ${productId}`}
			className={className}
			// Only here since we want to force a text on the underlying load more list,
			// this list does not have a load more button.
			loadMoreButtonText="Load more products"
		/>
	);
}
ProductDetailsBundleProducts.displayName = 'ProductDetailsBundleProducts';
